/* eslint-disable import/prefer-default-export */

export const HIDDEN_CATEGORIES = [
  'Hidden',
];